<div>
  <div class="file-input-progress__header">
    <p class="title">{{ file.name }}</p>
  </div>

  <div>
    <div class="file-input-progress__info">
      <ng-container *ngIf="model">
        <span class="progress">{{ model | number: '1.0-0' }}%</span>
        - Téléversement en cours...
        <button
          type="button"
          class="btn-clean cancel"
          (click)="cancel.emit()"
          aria-label="Annuler le téléversement du fichier"
        >
          Annuler
        </button>
      </ng-container>

      <ng-container *ngIf="!model">Le téléversement va commencer.</ng-container>
    </div>

    <div class="file-input-progress__progress">
      <div class="progress__completed" [style.width]="model ? model + '%' : '0%'"></div>
    </div>
  </div>
</div>
